module.exports = __webpack_public_path__ + "img/22_58.02d788c0.png";